"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _redux = require("redux");
var _reactRedux = require("react-redux");
var _classnames = _interopRequireDefault(require("classnames"));
var _styles = require("@mui/styles");
var _material = require("@mui/material");
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _colors = require("@mui/material/colors");
var _CheckCircle = _interopRequireDefault(require("@mui/icons-material/CheckCircle"));
var _Warning = _interopRequireDefault(require("@mui/icons-material/Warning"));
var _Error = _interopRequireDefault(require("@mui/icons-material/Error"));
var _Info = _interopRequireDefault(require("@mui/icons-material/Info"));
var _action_notice = require("../actions/action_notice");
const stylesBar = theme => ({
  success: {
    backgroundColor: _colors.green[600]
  },
  error: {
    backgroundColor: theme.palette.error.dark
  },
  info: {
    backgroundColor: theme.palette.primary.dark
  },
  warning: {
    backgroundColor: _colors.amber[700]
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit
  },
  message: {
    display: 'flex',
    alignItems: 'center'
  }
});
const variantIcon = {
  success: _CheckCircle.default,
  warning: _Warning.default,
  error: _Error.default,
  info: _Info.default
};
const BarContent = props => {
  const {
      classes,
      className,
      message,
      onClose,
      variant,
      open
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "message", "onClose", "variant", "open"]);
  const Icon = variantIcon[variant];
  return /*#__PURE__*/_react.default.createElement(_material.Snackbar, {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    open: open,
    autoHideDuration: 6000,
    onClose: onClose
  }, /*#__PURE__*/_react.default.createElement(_material.SnackbarContent, (0, _extends2.default)({
    className: (0, _classnames.default)(classes[variant], className),
    "aria-describedby": "client-snackbar",
    message: /*#__PURE__*/_react.default.createElement("span", {
      id: "client-snackbar",
      className: (0, _classnames.default)(classes.message, 'txt-notice')
    }, /*#__PURE__*/_react.default.createElement(Icon, {
      className: (0, _classnames.default)(classes.icon, classes.iconVariant)
    }), message),
    action: [/*#__PURE__*/_react.default.createElement(_material.IconButton, {
      key: "close",
      "aria-label": "Close",
      color: "inherit",
      className: classes.close,
      onClick: onClose,
      size: "large"
    }, /*#__PURE__*/_react.default.createElement(_Close.default, {
      className: classes.icon
    }))]
  }, other)));
};
BarContent.propTypes = {
  classes: _propTypes.default.object.isRequired,
  className: _propTypes.default.string.isRequired,
  message: _propTypes.default.node.isRequired,
  onClose: _propTypes.default.func.isRequired,
  open: _propTypes.default.bool.isRequired,
  variant: _propTypes.default.oneOf(['success', 'warning', 'error', 'info']).isRequired
};
const BarContentWrapper = (0, _styles.withStyles)(stylesBar)(BarContent);

// - - - - - - - - - - - - - - - - - - - - - - - - - - -
//
// Notice
//
// - - - - - - - - - - - - - - - - - - - - - - - - - - -
const stylesNotice = theme => ({
  margin: {
    margin: theme.spacing.unit
  }
});
const BarContentMain = (variant, className, message, open, onClose) => /*#__PURE__*/_react.default.createElement(BarContentWrapper, {
  variant: variant,
  className: className,
  message: message,
  open: open,
  onClose: onClose
});
const Notice = _ref => {
  let {
    classes,
    noticeSt,
    manualClearAct
  } = _ref;
  const {
    status,
    message
  } = noticeSt;
  return /*#__PURE__*/_react.default.createElement("div", null, status && message ? BarContentMain(status, classes.margin, message, Boolean(status), manualClearAct) : null);
};
const mapStateToProps = state => ({
  noticeSt: state.notice
});
const mapDispatchToProps = dispatch => (0, _redux.bindActionCreators)({
  manualClearAct: _action_notice.manualClear
}, dispatch);
Notice.propTypes = {
  classes: _propTypes.default.object.isRequired,
  noticeSt: _propTypes.default.object.isRequired,
  manualClearAct: _propTypes.default.func.isRequired
};
var _default = exports.default = (0, _redux.compose)((0, _styles.withStyles)(stylesNotice), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(Notice);